var map = {
	"./de-DE/txt_wp-3times.png": "5499",
	"./en-GB/txt_wp-3times.png": "f064",
	"./en-US/txt_wp-3times.png": "ea06",
	"./es-ES/txt_wp-3times.png": "96b8",
	"./es-MX/txt_wp-3times.png": "c0f5",
	"./fr-CA/txt_wp-3times.png": "2879",
	"./fr-FR/txt_wp-3times.png": "6e7c",
	"./it-IT/txt_wp-3times.png": "c520",
	"./ja-JP/txt_wp-3times.png": "d6a7",
	"./pt-BR/txt_wp-3times.png": "327a",
	"./zh-TW/txt_wp-3times.png": "1064"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "001c";